import { useMemo } from 'react';
import { View, Text, useWindowDimensions } from 'react-native-web';

import { SubTabEnum } from '../../../shared/discover-tabs-enum';
import { DiscoverCard, DiscoverCardOld, DiscoverRentalCard } from '../components';
import responsiveStyles from '../styles';

const useProgramResultCards = (
  isDaily,
  subView,
  shouldSeePricesWithFees = false,
  discoverResultsMemo = []
) => {
  const layout = useWindowDimensions();
  const styles = responsiveStyles(layout, 695);

  const resultsView = useMemo(
    () =>
      discoverResultsMemo?.map(({ _id, leagueId: dailyProgramId, gameId, label, noResults }) => {
        if (noResults) {
          return (
            <View key="noResultLabel">
              <Text style={styles('noResultLabel')}>No results</Text>
            </View>
          );
        }

        if (label) {
          if (!isDaily) return null;
          const finalProgramId = _id || dailyProgramId || gameId;
          return (
            <View key={`${label}-${finalProgramId}`}>
              <Text style={styles('dateLabel')}>{label}</Text>
            </View>
          );
        }

        // allows events to be included
        if (isDaily) {
          return (
            <DiscoverCard
              gameId={gameId}
              programId={dailyProgramId}
              key={dailyProgramId || gameId}
              shouldSeePricesWithFees={shouldSeePricesWithFees}
            />
          );
        }

        switch (subView) {
          case SubTabEnum.BY_SPORT:
            return <DiscoverRentalCard key={`${_id}-sport`} id={_id} viewType="sportView" />;
          case SubTabEnum.BY_VENUE:
            return <DiscoverRentalCard key={`${_id}-venue`} id={_id} viewType="venueView" />;
          default:
            return (
              <DiscoverCardOld
                key={_id}
                programId={_id}
                shouldSeePricesWithFees={shouldSeePricesWithFees}
              />
            );
        }
      }),
    [discoverResultsMemo, shouldSeePricesWithFees, isDaily, styles, subView]
  );

  return resultsView || null;
};

export default useProgramResultCards;
